import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const WeddingsWrapper = styled.div`
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq('max', '768px')} {
    max-width: 100%;
  }

  .hero-component {

    .hero-container {
      .hero-container-inner {
        ${mq('max', '768px')} {
          height: unset !important;
          height: auto !important;
        }
        .content {
          .inner {
            margin: unset;
            width: 100%;
            height: 100%;

            // weddings-specific: widen hero description from the default 90%
            .hero-content {
              ${mq('max', '768px')} {
                width: 95%;
              }
            }
          }
        }
      }
    }

    .image-placeholder {

      ${mq('max', '768px')} {
        min-height: 500px;
        overflow-x: hidden !important;
        max-width: 100%;
        width: 100%;
        object-fit: contain;
      }
      
      span {
        transform-origin: 45% 40%;

        ${mq('max', '768px')} {
          max-width: 100%;
        }
        
        img {
          transform: scale(1.7);
          margin: 0 !important;
          transform-origin: 45% 40%;
          
          ${mq('max', '768px')} {
            height: 500px;
            width: auto;
          }
        }
      } 
    }
  }
`

export const WhyGlamsquadWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: center;
  background-color: ${gsColors.khaki};
  padding: 50px 88px;

  ${mq('max', '1280px')} {
    padding: 50px 44px;
  }

  ${mq('max', '960px')} {
    padding: 50px 16px;
  }

  ${mq('max', '768px')} {
    padding: 44px 16px;
  }

  .reasons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;

    ${mq('max', '768px')} {
      flex-direction: column;
      gap: 27px;
    }

    .card {
      width: 100%;
      max-width: 411px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      text-align: left;
      padding-right: 20px;

      ${mq('max', '768px')} {
        h3 {
          font-size: 18px;
        }

        p {
          font-size: 16px;
        }
      }
    }
  }
`

export const AsSeenInWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0;

  .bridal-mags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    width: 100%;
    max-width: 1024px;
    height: 100%;

    ${mq('max', '1024px')} {
      max-width: 600px;
    }

    .wedding-as-seen-logo {
      height: 40px;
      margin: 1rem;

      ${mq('max', '500px')} {
        height: 30px;
      }

      ${mq('max', '428px')} {
        height: 25px;
      }

      img {
        width: auto;
        max-height: 40px;

        ${mq('max', '500px')} {
          max-height: 30px;
        }

        ${mq('max', '428px')} {
          max-height: 25px;
        }
      }
    }
  }
`

export const ImageScrollWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  padding-top: 24px;
  margin-bottom: 88px;

  ${mq('max', '768px')} {
    max-width: initial !important;
  }

  .grid-container {
    white-space: nowrap;
    width: 100%;
    height: 100%;

    ${mq('max', '768px')} {
      width: 100%;
    }

    li {
      max-width: 400px;
      min-width: 400px;
      margin: 0 1px !important;

      ${mq('max', '768px')} {
        min-width: 300px;
        max-width: 300px;
      }
    }

    .react-multiple-carousel__arrow {
      z-index: 0;
    }


    .wedding-photo-container {
      height: 100%;
      display: inline-block;
      wrap: no-wrap;
      margin: 2px;
      width: 400px !important;
      box-sizing: border-box;
      position: relative;
      max-height: 490px;

      ${mq('max', '768px')} {
        height: 400px !important;
        width: auto !important;
      }
      
      img {
        width: 100%;
        height: 100% !important;
        image-position: 50% 50%;
        object-fit: cover;
        max-height: 490px;

        ${mq('max', '768px')} {
          max-height: 400px !important;
        }
      }
    }

  }
`

export const RequestWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 0 0;
  gap: 22px;

  ${mq('max', '768px')} {
    padding: 72px 0 32px;
  }

`
